export default function ImagePreloader() {
  [
    process.env.PUBLIC_URL + '',
  ].forEach((picture) => {
    // console.log(picture);
    const img = new Image();
    img.src = picture;
  });
}
